export default {
      id: "txt_align-center-usage",
      viewBox: "0 0 18 17",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_align-center",
      toString: function () {
        return this.url;
      }
    }